declare global {
  interface OSSFormSec {
    OSSAccessKeyId: string,
    policy: string,
    signature: string,
    startsWith: string,
    saveName: string,
    host: string,
    callback: string,
    x_upload_url?: string
  }
}
export const useTicket = {
  add({ userId, opt }) {
    return useAPI().post(`users/${userId}/tickets`, { body: opt }) as Promise<ticketsAttributes>
  },
  getSign(opt) {
    return useAPI().post(`images`, { body: opt }) as Promise<OSSFormSec>
  },
  // get all replies of a ticket or original ticket
  get({ ticketId, params }: { ticketId: number; params: { originalTicket?: boolean } }) {
    return useAPI().get(`tickets/${ticketId}`, { params }) as Promise<ticketsAttributes[] | ticketsAttributes>
  },
  getAll({ userId, params }) {
    return useAPI().get(`users/${userId}/tickets`, { params }) as Promise<ticketsAttributes[]>
  },
  update({ ticketId, opt }) {
    return useAPI().put(`tickets/${ticketId}`, { body: opt })
  },
  close({ ticketId }) {
    return useAPI().delete(`tickets/${ticketId}`, {})
  },
  reopen({ ticketId }) {
    return useAPI().post(`tickets/${ticketId}/reopen`)
  },
  reply({ ticketId, content, html }) {
    return useAPI().post(`tickets/${ticketId}`, { body: { content, html } }) as Promise<ticketsAttributes>
  },
}
